import {BaseApi, configuration} from '../../api/base/BaseApi';
import {AdvertiserControllerApi, AdvertiserOptionBean, ChangePasswordBean, CountryBean, UserPropsBean} from '../../api/base/api';
import {processError} from '../../api/fetch';
import {businessDevelopmentStore} from '../../util/BusinessDevelopmentStore';

class AdvAccountApi extends BaseApi {
    api: AdvertiserControllerApi;

    constructor() {
        super();
        this.api = new AdvertiserControllerApi(configuration, configuration.basePath, this.fetch);
    }

    changePassword(bean: ChangePasswordBean): Promise<void> {
        return this.api.changePass(bean).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }

    updateTimezone(timezone: string): Promise<void> {
        return this.api.changeTimezone(timezone).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }

    updateDefaultReportType(reportType: string): Promise<void> {
        return this.api.changeDefaultReportType(reportType).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }

    countries(advertiserId?: number): Promise<Array<CountryBean>> {
        return this.api.countries(advertiserId, businessDevelopmentStore.accountAdvertiserId).then(countries => {
            return Promise.resolve(countries);
        }).catch(err => {
            return processError(err);
        });
    }

    getUserData(advertiserId?: number): Promise<UserPropsBean> {
        return this.api.userProps(advertiserId, businessDevelopmentStore.accountAdvertiserId).then(account => {
            return Promise.resolve(account);
        }).catch(err => {
            return processError(err);
        });
    }

    getUserAdvertisers(): Promise<Array<AdvertiserOptionBean>> {
        return this.api.getUserAdvertisers().catch(err => {
            return processError(err);
        });
    }
}

export const advAccountApi = new AdvAccountApi();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/account/AdvAccountApi.ts